import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import CommonUtil from "../../../common/commonUtil";
import { apiKeyCheck, versionGetApi } from "../../../const";
import { getAreaList, getCityListByCountry, getCountryListByArea, getPropertyList, getRecommendPlanList } from "../../../const/RTCC";
import Const from "../../../const/RTCC/Const";
import { useRtoaster } from "../../../hooks/useRtoaster";
import '../../../resources/css/search/search.css';
import common from "../../../resources/RTCC/js/common/common";
import { BreadCrumb } from '../../molecules/RTCC/breadCrumb';
import './../../../resources/RTCC/css/reservation/reservation.css';
import { FooterContainer } from './footerContainer';
import { RecommendationPlanContainer } from './recommendationPlanContainer';
import VacancyInfoContainer from "./vacancyInfoContainer";

const roomsOverseas = [
    { id: "1", value: "1室", selected: true },
    { id: "2", value: "2室", selected: false },
    { id: "3", value: "3室", selected: false },
];
const roomsHome = [
    { id: "1", value: "1室", selected: true },
    { id: "2", value: "2室", selected: false },
    { id: "3", value: "3室", selected: false },
    { id: "4", value: "4室", selected: false },
];
const humans = [];
for (var i = 1; i <= Const.MAX_CAPACITY; i++) {
    if (i == 1) {
        humans.push({ id: i + "", value: i + "人", selected: true });
    } else {
        humans.push({ id: i + "", value: i + "人", selected: false });
    }
}
const ageList = [];
for (var i = 0; i <= Const.CHILD_AGE; i++) {
    if (i == 0) {
        ageList.push({ id: i + "", value: i + "歳", selected: true });
    } else {
        ageList.push({ id: i + "", value: i + "歳", selected: false });
    }
}
const RtccReservationContainer = (props) => {
    const {
        state,
        // detailCondition,
        keyWord,
        area,
        dispArea,
        country,
        dispCountry,
        city,
        dispCity,
        group,
        roomHome,
        roomOverseas,
        human,
        dispHuman,
        stayInfo,
        age,
        customerAge,
        propertyInfo,
        catalogFlg,
        // setDetailCondition,
        setKeyWord,
        setArea,
        setCountry,
        setCity,
        setGroup,
        setRoomHome,
        setRoomOverseas,
        setHuman,
        setDispHuman,
        setAge,
        setStayInfo,
        setSearchResult,
        setCustomerAge,
        setPropertyInfo,
        setCheckIn,
        setCheckOut,
        login,
        onClickOpenReservationPopupWindow,
        onClickOpenCheckListWindow,
        onChangeRoom,
        onChangeHuman,
        onClickOpenCalendarWindow,
        onClickOpenDetailConditionWindow,
        setBeforeAreaId,
        setBeforeCountryId,
        setPopupData,
        onClickOpenWindow,
        onClickOpenSelectAreaWindow,
        setDisplaySwitchTab,
        setSelectRecommendFlg,
        createAgeCountList } = props;

    const [NotSearch, setNotSearch] = useState(false);
    const [NotStart, setNotStart] = useState(false);
    const [NotDate, setNotDate] = useState(false);
    const [NotFacility, setNotFacility] = useState(false);


    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const [displaySwitch, setDisplaySwitch] = useState(false);

    const [vacancyInfo, setVacancyInfo] = useState([]);
    const [vacancyWeek, setVacancyWeek] = useState([]);
    const [MonthHead, setMonthHead] = useState("");
    const [MonthLast, setMonthLast] = useState("");

    const [recommendPlanList, setRecommendPlanList] = useState([]);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);
    const [areaHome, setAreaHome] = useState([]);
    const [areaOverseas, setAreaOverseas] = useState([]);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            let rtccFlg = store.getState().rtccFlg;
            store.dispatch({ type: "CLEAR_STATE" });
            store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: rtccFlg } });
            if (catalogFlg){
                store.dispatch({ type: "CATALOG_FLG", payload: { catalogFlg: catalogFlg } });
                store.dispatch({ type: "AREA", payload: { area: area } });
                store.dispatch({ type: "DISP_AREA", payload: { dispArea: dispArea } });
                store.dispatch({ type: "COUNTRY", payload: { country: country } })
                store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: dispCountry } });
                store.dispatch({ type: "CITY", payload: { city: city } })
                store.dispatch({ type: "DISP_CITY", payload: { dispCity: dispCity } });
                store.dispatch({ type: "KEYWORD", payload: { keyWord: keyWord } });
            }
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: false } });
        store.dispatch({ type: "CATALOG_FLG", payload: { catalogFlg: false } });
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // API呼出等事前処理
    useEffect(() => {

        setLinkList([{ path: "/reserve/top", label: "HOME" }]);

        // キーワード設定
        setKeyWord(keyWord);

        // エリア設定処理
        common.doPost(getAreaList, {}, afterGetArea);

        // チェックイン・アウト日付初期化
        let iniCheckInDate = new Date();
        let iniCheckOutDate = new Date();
        iniCheckInDate.setDate(iniCheckInDate.getDate() + 15);
        iniCheckOutDate.setDate(iniCheckOutDate.getDate() + 16);
        setCheckIn(iniCheckInDate);
        setCheckOut(iniCheckOutDate);

        // 部屋数設定処理
        setRoomOverseas(roomsOverseas);
        setRoomHome(roomsHome);
        // 人数設定処理
        setHuman(humans);
        setDispHuman("1");
        setStayInfo([{
            adultNum: "1",
            childNum: "0",
            ageList: []
        }])

        // 年齢リスト設定処理
        if (age.length < 1) {
            setAge(ageList)
        }
        else {
            setAge(age);
        }

        // // 詳細設定処理
        // if (detailCondition.length < 1) {
        //     setDetailCondition(detailConditions);
        // }
        // else {
        //     setDetailCondition(detailCondition);
        // }

        // おすすめプラン取得
        common.doPost(getRecommendPlanList, {}, afterGetRecommend);
        // プロパティ一覧取得
        common.doPost(getPropertyList, { propertyTypeList: ["CUSTOMER_AGE", "CUSTOMER_GENDER"] }, afterGetPropertyList);

    }, []);

    // おすすめプラン一覧取得後処理
    const afterGetRecommend = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            console.log(data.errorMessage);
            return;
        }
        setRecommendPlanList(data.planList);
    }
    // プロパティ一覧取得後処理
    const afterGetPropertyList = (res) => {
        let data = res.data;
        if (data) {
            if (data.propertyInfoList && data.propertyInfoList.length != 0) {
                let propertyInfoList = data.propertyInfoList;
                propertyInfoList.map((value, index) => {
                    let dataList = [];
                    switch (value.propertyType) {
                        case "CUSTOMER_AGE":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                // こども（添い寝）は一時的に非表示
                                if (property.propertyName != "こども（添い寝）") {
                                    if (propertyIndex == 0) {
                                        obj = { id: property.propertyId, value: property.propertyName, selected: true };
                                    } else {
                                        obj = { id: property.propertyId, value: property.propertyName, selected: false };
                                    }
                                    dataList.push(obj);
                                }
                            })
                            setCustomerAge(dataList);
                            break;
                        case "CUSTOMER_GENDER":
                            value.propertyList.map((property, propertyIndex) => {
                                let obj = {};
                                if (propertyIndex == 0) {
                                    obj = { checked: true, text: property.propertyName, value: property.propertyId };
                                } else {
                                    obj = { checked: false, text: property.propertyName, value: property.propertyId };
                                }
                                dataList.push(obj);
                            })
                            setPropertyInfo({ customerGender: dataList });
                            break;
                        default:
                            break;
                    }
                })
            }
        } else {
            // エラー処理
        }
    }

    // エリア一覧取得後処理
    const afterGetArea = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            console.log(data.errorMessage);
            return;
        }
        let areas = [];
        if (res.data.areaList) {
            setAreaHome(res.data.areaList.filter(value => {
                return value.areaId != "1"
            }));
            areas = res.data.areaList.filter(value => {
                return value.areaId == "1"
            });
            setAreaOverseas(areas);
        }
        // リスト作成
        if(catalogFlg){
            setDisplaySwitchTab(area[0].value != "1");
            setSelectRecommendFlg(true);
        } else {
            let dataList = CommonUtil.getRadioList(areas, "areaId", "areaName", false);
            setArea(dataList);
        }
    }

    // プラン詳細ポップアップ   
    const handlePlanDetail = (hotelId, planId) => {
        let popupData = {};
        recommendPlanList.map((plan) => {
            if (plan.hotelId == hotelId && plan.planId == planId) {
                popupData = {
                    propertyImages: plan.roomImagePath,
                    hotelName: plan.hotelName,
                    planId: plan.planId,
                    planName: plan.planName,
                    roomName: plan.roomName,
                    fee: "",
                    planDescriptions: plan.planDescriptions,
                    roomDescriptions: plan.roomDescriptions,
                    notes: plan.planRemark,
                    notification: plan.planNews,
                    cancelDescriptions: plan.planCancelContents,
                    recommendFlg: true,
                    areaId: plan.areaId,
                    countryId: plan.countryId,
                    cityId: plan.cityId,
                }
            }
        })
        setPopupData("プラン詳細", "planDetail", popupData);
    }

    // 国内海外切り替え
    const handleHomeOverseas = (flg) => {
        setDisplaySwitchTab(flg);
        setSelectRecommendFlg(false);
        if (flg) {
            setArea(CommonUtil.getRadioList(areaHome, "areaId", "areaName", false));
        } else {
            setArea(CommonUtil.getRadioList(areaOverseas, "areaId", "areaName", false));
        }
        setCountry([]);
        store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: "選択なし" } });
        setCity([]);
        store.dispatch({ type: "DISP_CITY", payload: { dispCity: "選択なし" } });
        store.dispatch({ type: "DISP_AREA", payload: { dispArea: "選択なし" } });
        store.dispatch({ type: "DISP_CITY", payload: { dispCity: "選択なし" } });
        store.dispatch({ type: "KEYWORD", payload: { keyWord: "" } });
    }

    // タブ表示切替
    const [displaySwitchHome, setDisplaySwitchHome] = useState(false);
    const [displaySwitchOversea, setDisplaySwitchOversea] = useState(false);

    return (
        <div >
            {/* タブ表示切替・海外／国内 */}
            <div className="tabnavi">
                <button
                    onClick={() => handleHomeOverseas(false)}
                    type="submit"
                    className={!isWideTablet ? state.displaySwitchTab ? "rtccTabStyle" : "rtccTabStyle2" : state.displaySwitchTab ? "rtccTabStyleMobile" : "rtccTabStyle2Mobile"}
                    tabIndex="1"
                >RTCCハワイ<br />（海外募集型企画旅行）
                </button>
                <button
                    onClick={() => handleHomeOverseas(true)}
                    type="submit"
                    className={!isWideTablet ? state.displaySwitchTab ? "rtccTabStyle2" : "rtccTabStyle" : state.displaySwitchTab ? "rtccTabStyle2Mobile" : "rtccTabStyleMobile"}
                    tabIndex="2"
                >RTCC宿泊<br />（国内・海外手配旅行）
                </button>
            </div>
            <div className="breadCrumbWrapper">
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="RTCC予約"
                    lastLabelClassName="lastLabel"
                />
            </div>
            <div className={isMobilePhone ? "searchInnerWrapperSp" : "searchInnerWrapper"}>
                {/*国内・海外*/}
                <div id="home" style={state.displaySwitchTab ? { display: "block" } : { display: "none" }} >
                    <div className="searchWrapper">
                        {/* 国内条件 */}
                        <div id="homecondition" style={displaySwitchHome ? { display: "none" } : { display: "block" }}>
                            <div className="vacancy__title">
                                {isMobilePhone ?
                                    <>
                                        <h5>条件を指定して探す</h5>
                                        <h6 className="keepLink" onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h6>
                                    </>
                                    :
                                    <>
                                        <h3>条件を指定して探す</h3>
                                        <h4 className="keepLink" onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h4>
                                    </>
                                }
                            </div>
                            <VacancyInfoContainer
                                state={state}
                                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                setBeforeAreaId={setBeforeAreaId}
                                setBeforeCountryId={setBeforeCountryId}
                                displaySwitch={displaySwitch}
                                displaySwitchTab={state.displaySwitchTab}
                                onClickOpenDetailConditionWindow={onClickOpenDetailConditionWindow}
                                setVacancyInfo={setVacancyInfo}
                                setVacancyWeek={setVacancyWeek}
                                setMonthHead={setMonthHead}
                                setMonthLast={setMonthLast}
                                selectRecommendFlg={state.selectRecommendFlg}
                                createAgeCountList={createAgeCountList} />
                        </div>
                    </div>
                </div>

                {/*ハワイ*/}
                <div id="overseas" style={state.displaySwitchTab ? { display: "none" } : { display: "block" }} >
                    <div className="searchWrapper">
                        {/* 海外条件 */}
                        <div id="overseascondition" style={displaySwitchOversea ? { display: "none" } : { display: "block" }}>
                            <div className="vacancy__title">
                                {isMobilePhone ?
                                    <>
                                        <h5>条件を指定して探す</h5>
                                        <h6 className="keepLink" onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h6>
                                    </>
                                    :
                                    <>
                                        <h3>条件を指定して探す</h3>
                                        <h4 className="keepLink" onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}>　&nbsp;保存した検索条件</h4>
                                    </>
                                }
                            </div>
                            <VacancyInfoContainer
                                state={state}
                                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                setBeforeAreaId={setBeforeAreaId}
                                setBeforeCountryId={setBeforeCountryId}
                                displaySwitch={displaySwitch}
                                displaySwitchTab={state.displaySwitchTab}
                                onClickOpenDetailConditionWindow={onClickOpenDetailConditionWindow}
                                setVacancyInfo={setVacancyInfo}
                                setVacancyWeek={setVacancyWeek}
                                setMonthHead={setMonthHead}
                                setMonthLast={setMonthLast}
                                selectRecommendFlg={state.selectRecommendFlg}
                                setSelectRecommendFlg={setSelectRecommendFlg}
                                createAgeCountList={createAgeCountList} />
                        </div>
                    </div>
                </div>
            </div>
            {recommendPlanList ?
                <RecommendationPlanContainer
                    state={state}
                    recommendPlanList={recommendPlanList}
                    handlePlanDetail={handlePlanDetail}
                />
                : null}
            <FooterContainer />
        </div>

    );
};


const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        group: state.group,
        keyWord: state.keyWord,
        roomHome: state.roomHome,
        roomOverseas: state.roomOverseas,
        human: state.human,
        dispHuman: state.dispHuman,
        stayInfo: state.stayInfo,
        age: state.age,
        course: state.course,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        login: state.login,
        kaiinken: state.kaiinken,
        area: state.area,
        dispArea: state.dispArea,
        country: state.country,
        dispCountry: state.dispCountry,
        city: state.city,
        dispCity: state.dispCity,
        checkIn: state.checkIn,
        propertyInfo: state.propertyInfo,
        catalogFlg: state.catalogFlg
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setKeyWord: (item) => {
            dispatch({ type: "KEYWORD", payload: { keyWord: item } })
        },
        setRoomHome: (item) => {
            dispatch({ type: "ROOM_HOME", payload: { roomHome: item } })
        },
        setRoomOverseas: (item) => {
            dispatch({ type: "ROOM_OVERSEAS", payload: { roomOverseas: item } })
        },
        setHuman: (item) => {
            dispatch({ type: "HUMAN", payload: { human: item } })
        },
        setDispHuman: (item) => {
            dispatch({ type: "DISP_HUMAN", payload: { dispHuman: item } })
        },
        setStayInfo: (item) => {
            dispatch({ type: "STAY_INFO", payload: { stayInfo: item } })
        },
        setAge: (item) => {
            dispatch({ type: "AGE", payload: { age: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: { kaiinken: item } })
        },
        setArea: (item) => {
            dispatch({ type: "AREA", payload: { area: item } })
        },
        setCountry: (item) => {
            dispatch({ type: "COUNTRY", payload: { country: item } })
        },
        setCity: (item) => {
            dispatch({ type: "CITY", payload: { city: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setCustomerAge: (item) => {
            dispatch({ type: "CUSTOMER_AGE", payload: { customerAge: item } })
        },
        setPropertyInfo: (item) => {
            dispatch({ type: "PROPERTY_INFO", payload: { propertyInfo: item } })
        },
        setCatalogFlg: (item) => {
            dispatch({ type: "CATALOG_FLG", payload: { propertyInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RtccReservationContainer);

const styles = {
    link: {
        display: "inline-flex",
        padding: "3px",
        color: "white",
        fontSize: "small",
        alieItems: "center",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
}
